import React, { useContext } from 'react';
import { styled } from '@this/constants/themes';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import DateRangeIcon from '@material-ui/icons/DateRange';
import AppointContext from '@this/components/appoint/appoint_context';
import Link from '@material-ui/core/Link';
import { Link as RouterLink } from 'react-router-dom';

interface Props {
  onDrawerOpen: () => void;
  menuButtonRef: React.MutableRefObject<null>;
  setFixWithCalendar: (v: boolean) => void;
}

const Header = ({ onDrawerOpen, menuButtonRef, setFixWithCalendar }: Props) => {
  const contextValue = useContext(AppointContext);

  return (
    <TheHeader position="relative" isMobile={contextValue.isMobile}>
      <Toolbar
        style={{
          minHeight: '54px',
          paddingLeft: contextValue.isMobile ? '10px' : '20px',
          flexDirection: contextValue.isMobile ? 'row-reverse' : 'row'
        }}
      >
        {contextValue.isMobile && contextValue.fixWithCalendar !== null && (
          <Button
            variant="outlined"
            color="primary"
            size="small"
            startIcon={contextValue.fixWithCalendar ? <FormatListBulletedIcon /> : <DateRangeIcon />}
            onClick={() => setFixWithCalendar(!contextValue.fixWithCalendar)}
            style={{ padding: '6px 12px' }}
          >
            {`${contextValue.fixWithCalendar ? 'リスト' : 'カレンダー'}から選択`}
          </Button>
        )}
        <H1>
          <TheLink to="/">
            <img
              src="/images/aicalendar/aicalendar_logo.png"
              height="26"
              alt="AIカレンダー"
              style={{ display: 'block' }}
            />
          </TheLink>
        </H1>
        <TheIconButton
          edge="end"
          color="inherit"
          aria-label="menu"
          ref={menuButtonRef}
          onClick={() => onDrawerOpen()}
          isMobile={contextValue.isMobile}
        >
          <MenuIcon fontSize="small" />
        </TheIconButton>
      </Toolbar>
    </TheHeader>
  );
};

const TheHeader = styled(AppBar)<{ isMobile: boolean }>`
  height: 54px;
  background-color: #f7f7f7;
  box-shadow: none;
  z-index: 0;

  ${props =>
    props.isMobile &&
    `
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
  `}
`;

const TheLink = styled(props => <Link {...props} component={RouterLink} />)`
  color: white;
  text-decoration: none;
`;

const H1 = styled(Typography).attrs(() => ({ variant: 'h1' }))`
  font-size: 20px;
  &&& {
    font-weight: 600;
  }
  margin-right: auto;
`;

const TheIconButton = styled(IconButton)<{ isMobile: boolean }>`
  padding: 8px;
  background-color: #243565;

  ${props =>
    props.isMobile &&
    `
    margin-right: 6px;
    color: #243565;
    background-color: transparent;
  `}
`;

export default Header;
